import React from 'react';

export const TableHeader = () => (
    <thead className="kt-datatable__head">
    <tr className="kt-datatable__row">
        <th width="180px" className="kt-datatable__cell"><span>Наименование</span></th>
        <th width="40px" className="kt-datatable__cell"><span></span></th>
        <th width="120px" className="kt-datatable__cell"><span>Количество</span></th>
        <th width="120px" className="kt-datatable__cell"><span>Цена</span></th>
        <th width="310px" className="kt-datatable__cell"><span>Сумма</span></th>
        <th style={{textAlign: 'right'}} width="180px" className="kt-datatable__cell"></th>
    </tr>
    </thead>
);